<div
  [formGroup]="group"
  [ngClass]="[
    'ng-dynamic-forms-' + model.type.toLowerCase(),
    getClass('element', 'container'),
    getClass('grid', 'container')
  ]"
>
  <label
    *ngIf="!hasMatFormField && !isCheckbox && hasLabel"
    [for]="id"
    [innerHTML]="model.label"
    [ngClass]="[
      getClass('element', 'label'),
      getClass('grid', 'label'),
      getLanguage === 'ja' ? 'label-jp-message-width' : ''
    ]"
  ></label>

  <div [ngClass]="[getLanguage === 'ja' ? 'radio-width' : '']">
    <ng-container *ngTemplateOutlet="startTemplate?.templateRef; context: model"></ng-container>

    <ng-container #componentViewContainer></ng-container>
  </div>

  <ng-container *ngIf="!hasMatFormField">
    <div class="error-jp-container" [ngClass]="[getLanguage === 'ja' ? 'err-jp-message-width' : '']">
      <mat-error class="ml-md-2" *ngFor="let message of errorMessages">{{ message }}</mat-error>
    </div>
  </ng-container>

  <ng-container *ngTemplateOutlet="endTemplate?.templateRef; context: model"></ng-container>

  <ng-content></ng-content>
</div>
<ng-container *ngIf="controlTooltipIconConfig$ | async as tooltipIconConfig">
  <app-tooltip-icon
    [matIconName]="tooltipIconConfig.matIconName"
    [matIconTheme]="tooltipIconConfig.matIconTheme"
    [size]="tooltipIconConfig.size"
    [tooltipContent]="tooltipIconConfig.contentKey | cxTranslate"
    [closeOnScroll]="true"
    placement="bottom"
  ></app-tooltip-icon>
</ng-container>
